import React from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

// Used by styled-jsx, and emotion to provide the nonce in the inline styles it generates
// https://github.com/vercel/styled-jsx#content-security-policy
const nonce = document.querySelector<HTMLMetaElement>('meta[property="csp-nonce"]')?.content;

// Used by emotion
export const cache = createCache({
  key: 'console',
  nonce,
  prepend: true,
});

function StylesProvider({ children }: { children: React.ReactNode }) {
  return <CacheProvider value={cache}>{children}</CacheProvider>;
}

export default StylesProvider;
